export const TOAST_TTL = 3000;

export enum ToastTypes {
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
}
